class GTMService {
  public static initialiseGTM = (window: Window, shadowRoot: ShadowRoot | undefined, gtmId: string) => {
    this.createGTMElement(window, shadowRoot, gtmId);
    this.addListner();
  };

  private static createGTMElement = (window: Window, shadowRoot: ShadowRoot | undefined, gtmId: string) => {
    // eslint-disable-next-line no-param-reassign
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'gtm.start':
        new Date().getTime(),
      event: 'gtm.js',
    });
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    shadowRoot?.appendChild(script);
  };

  private static addListner = () => {
    const eventName = 'click';
    const useCapture = true;

    const callback = (event: any) => {
      if ('composed' in event && typeof event.composedPath === 'function') {
        const path = event.composedPath();
        const targetElement = path[0];

        const shadowFound = path.length ? path.filter((i: any) => !targetElement.shadowRoot && !!i.shadowRoot).length > 0 : false;

        if (shadowFound) {
          window.dataLayer.push({
            event: 'gtm.click',

            'gtm.element': targetElement,
            'gtm.elementClasses': targetElement.className || '',
            'gtm.elementId': targetElement.id || '',
            'gtm.elementTarget': targetElement.target || '',
            'gtm.elementUrl': targetElement.href || targetElement.action || '',
            page_location: JSON.stringify(window.location),
            inShadowDom: shadowFound,

          });
        } else {
          window.dataLayer.push({
            event: 'gtm.click',
            inShadowDom: shadowFound,
          });
        }
      }
    };

    document.addEventListener(eventName, callback, useCapture);
  };
}

export { GTMService };
